import Field from '../../Field';
import { type FieldContentsData } from 'javascripts/shared-types';
import moment from 'moment';
import { dateFormattedWithUserLocale } from 'javascripts/util/dateFns';

export class CreatedAt extends Field {
  static get disableFieldForModelNames() {
    return ['Release', 'ReleasePhase', 'Task'];
  }

  static attributesForModel() {
    return ['createdAt'];
  }

  get title() {
    return 'Created at';
  }

  exampleContents(): FieldContentsData {
    return {
      text: dateFormattedWithUserLocale(moment().add(3, 'months')),
      icon: { name: 'fa-regular fa-lightbulb' },
    };
  }

  contentsForRecord(record): FieldContentsData {
    if (record.createdAt) {
      return {
        text: dateFormattedWithUserLocale(record.createdAt),
        icon: { name: 'fa-regular fa-lightbulb' },
      };
    }

    return {};
  }
}
